import { init } from '@orama/cuid2';


export const GenTesteeId = init({
    length: 20
});

